module.exports = __webpack_public_path__ + "img/red.e3b804a0.svg";